import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
    SEARCH_MEMBERS,
    SEARCH_MEMBERS_SUCCESS,
    SEARCH_MEMBERS_FAILED,
    SEARCH_NON_MEMBERS,
    SEARCH_NON_MEMBERS_SUCCESS,
    SEARCH_NON_MEMBERS_FAILED,
    VIEW_MEMBER,
    VIEW_MEMBER_SUCCESS,
    VIEW_MEMBER_FAILED,
    CHANGE_STATUS_MEMBER_SUCCESS,
    CHANGE_STATUS_MEMBER_FAILED,
    BACK_TO_LOGIN,
    NON_MEMBER_POINT_TRANSACTION,
    NON_MEMBER_POINT_TRANSACTION_SUCCESS,
    NON_MEMBER_POINT_TRANSACTION_FAILED
} from "constants/ActionTypes";
import {
    searchMembersApi,
    searchNonMembersApi,
    viewMemberApi,
    changeStatusApi,
    approvalMemberApi,
    uploadMemberApi,
    uploadTransactionApi,
    getNonMemberPointTransactionApi,
    memberDelinquencyApi,
    viewMemberDelinquencyApi,
    getPointDetailApi,
    deleteMemberApi,
    uploadTransactionS3Api,
    uploadOfflineRedemptionApi,
    searchHistoryApi,
    downloadHistoryApi
} from "../../appRedux/api/Member";
import { apiHandler, IDP_INQUIRY_SUCCESS, IDP_MUTATION_SUCCESS } from "./handler";
import {
    CHANGE_STATUS_MEMBER,
    UPLOAD_MEMBER,
    UPLOAD_MEMBER_FAILED,
    // UPLOAD_MEMBER_SUCCESS,
    UPLOAD_TRANSACTION,
    UPLOAD_TRANSACTION_SUCCESS,
    UPLOAD_TRANSACTION_FAILED,
    UPLOAD_OFFLINE_REDEMPTION,
    UPLOAD_OFFLINE_REDEMPTION_SUCCESS,
    UPLOAD_OFFLINE_REDEMPTION_FAILED,
    APPROVAL_MEMBER_SUCCESS,
    APPROVAL_MEMBER_FAILED,
    APPROVAL_MEMBER,
    DOWNLOAD_SUCCESS,
    DOWNLOAD_NON_MEMBER_SUCCESS,
    MEMBER_DELINQUENCY,
    MEMBER_DELINQUENCY_SUCCESS,
    MEMBER_DELINQUENCY_FAILED,
    VIEW_MEMBER_DELINQUENCY,
    VIEW_MEMBER_DELINQUENCY_SUCCESS,
    VIEW_MEMBER_DELINQUENCY_FAILED,
    GET_POINT_DETAIL_SUCCESS,
    GET_POINT_DETAIL_FAILED,
    GET_POINT_DETAIL,
    DELETE_MEMBER,
    DELETE_MEMBER_SUCCESS,
    DELETE_MEMBER_FAILED,
    SEARCH_HISTORY,
    SEARCH_HISTORY_SUCCESS,
    SEARCH_HISTORY_FAILED,
    DOWNLOAD_HISTORY,
    DOWNLOAD_HISTORY_SUCCESS,
    DOWNLOAD_HISTORY_FAILED
} from "../../constants/ActionTypes";

function* fetchSearchMembers({ payload }) {
    if (payload != null) {
        try {
            const searchMembersData = yield call(searchMembersApi, payload);
            if (searchMembersData.data.abstractResponse.responseStatus === "MEM000") {
                yield put({
                    type: SEARCH_MEMBERS_SUCCESS,
                    payload: searchMembersData.data
                });
            } else if (searchMembersData.data.abstractResponse.responseStatus === "ERROR016") {
                let resp = {
                    member: [],
                    recordInfo: {}
                };
                yield put({ type: SEARCH_MEMBERS_SUCCESS, payload: resp });
            } else {
                yield put({
                    type: SEARCH_MEMBERS_FAILED,
                    payload: searchMembersData.data.abstractResponse.responseMessage
                });
            }
        } catch (error) {
            if (error.response.status === 500) {
                yield put({
                    type: SEARCH_MEMBERS_FAILED,
                    payload: error.response.data.responseMessage
                });
            } else if (error.response !== undefined) {
                if (error.response.data.abstractResponse.responseStatus === "AUTH001") {
                    yield put({
                        type: BACK_TO_LOGIN,
                        payload: error.response.data.abstractResponse.responseMessage
                    });
                } else {
                    yield put({
                        type: SEARCH_MEMBERS_FAILED,
                        payload: error.response.data.abstractResponse.responseMessage
                    });
                }
            } else {
                yield put({
                    type: SEARCH_MEMBERS_FAILED,
                    payload: "Sorry, this feature is not accessible at this time."
                });
            }
        }
    }
}

function* fetchSearchNonMembers({ payload }) {
    if (payload != null) {
        try {
            const searchMembersData = yield call(searchNonMembersApi, payload);
            if (payload.isDownload) {
                yield put({
                    type: DOWNLOAD_NON_MEMBER_SUCCESS,
                    payload: searchMembersData.data
                });
            } else {
                yield put({
                    type: SEARCH_NON_MEMBERS_SUCCESS,
                    payload: searchMembersData.data
                });
            }
        } catch (error) {
            if (error.response !== undefined) {
                if (error.response.status === 500) {
                    yield put({
                        type: SEARCH_NON_MEMBERS_FAILED,
                        payload: error.response.data.responseMessage
                    });
                } else if (error.response.data.abstractResponse.responseStatus === "AUTH001") {
                    yield put({
                        type: BACK_TO_LOGIN,
                        payload: error.response.data.abstractResponse.responseMessage
                    });
                } else {
                    yield put({
                        type: SEARCH_NON_MEMBERS_FAILED,
                        payload: "Sorry, this feature is not accessible at this time."
                    });
                }
            } else {
                yield put({
                    type: SEARCH_NON_MEMBERS_FAILED,
                    payload: "Sorry, this feature is not accessible at this time."
                });
            }
        }
    }
}

function* fetchNonMemberPointTransaction({ payload }) {
    if (payload != null) {
        try {
            const data = yield call(getNonMemberPointTransactionApi, payload);
            if (payload.isDownload) {
                yield put({ type: DOWNLOAD_SUCCESS, payload: data.data });
            } else {
                yield put({
                    type: NON_MEMBER_POINT_TRANSACTION_SUCCESS,
                    payload: data.data
                });
            }
        } catch (error) {
            if (error.response.status === 500) {
                yield put({
                    type: NON_MEMBER_POINT_TRANSACTION_FAILED,
                    payload: error.response.data.responseMessage
                });
            } else if (error.response !== undefined) {
                if (error.response.data.abstractResponse.responseStatus === "AUTH001") {
                    yield put({
                        type: BACK_TO_LOGIN,
                        payload: error.response.data.abstractResponse.responseMessage
                    });
                } else {
                    yield put({
                        type: NON_MEMBER_POINT_TRANSACTION_FAILED,
                        payload: error.response.data.abstractResponse.responseMessage
                    });
                }
            } else {
                yield put({
                    type: NON_MEMBER_POINT_TRANSACTION_FAILED,
                    payload: "Sorry, this feature is not accessible at this time."
                });
            }
        }
    }
}

function* fetchViewMember({ payload }) {
    if (payload != null) {
        const { ok, data, message } = yield* apiHandler(viewMemberApi, payload, {
            successCodes: ['MEM000', ...IDP_INQUIRY_SUCCESS],
        });

        if (ok) {
            yield put({
                type: VIEW_MEMBER_SUCCESS,
                payload: data.body != null ? data.body : data.member,
            });
        } else {
            yield put({ type: VIEW_MEMBER_FAILED, payload: message });
        }
    }
}

function* postChangeStatusMember({ payload }) {
    if (payload != null) {
        const { ok, data, message } = yield* apiHandler(changeStatusApi, payload, {
            successCodes: ['MEM000', ...IDP_INQUIRY_SUCCESS],
        });

        if (ok) {
            yield put({
                type: CHANGE_STATUS_MEMBER_SUCCESS,
                payload: data.body != null ? data.body : data.member,
            });
        } else {
            yield put({ type: CHANGE_STATUS_MEMBER_FAILED, payload: message });
        }
    }
}

function* postUploadMember({ payload }) {
    if (payload != null) {
        try {
            let uploadMemberData = yield call(uploadMemberApi, payload);
            if (uploadMemberData.data.abstractResponse[0].responseStatus === "MEM000") {
                yield put({
                    type: UPLOAD_TRANSACTION_SUCCESS,
                    payload: uploadMemberData.data
                });
            } else {
                yield put({
                    type: UPLOAD_MEMBER_FAILED,
                    payload: uploadMemberData.data.abstractResponse[0].responseMessage
                });
            }
        } catch (error) {
            if (error.response !== undefined) {
                if (error.response.data.abstractResponse.responseStatus === "AUTH001") {
                    yield put({
                        type: BACK_TO_LOGIN,
                        payload: error.response.data.abstractResponse.responseMessage
                    });
                } else {
                    yield put({
                        type: UPLOAD_MEMBER_FAILED,
                        payload: error.response.data.abstractResponse.responseMessage
                    });
                }
            } else {
                yield put({
                    type: UPLOAD_MEMBER_FAILED,
                    payload: "Sorry, this feature is not accessible at this time."
                });
            }
        }
    }
}

function* postUploadTransaction({ payload }) {
    if (payload != null) {
        try {
            let uploadTransactionData = yield call(uploadTransactionS3Api, payload);
            if (uploadTransactionData.data.abstractResponse.responseStatus === "INQ001" || uploadTransactionData.data.abstractResponse.responseStatus === "BUT000") {
                yield put({
                    type: UPLOAD_TRANSACTION_SUCCESS,
                    payload: uploadTransactionData.data
                });
            } else if (uploadTransactionData.data.abstractResponse.responseStatus === "PPMUL008") {
                yield put({
                    type: UPLOAD_TRANSACTION_FAILED,
                    payload: uploadTransactionData.data
                });
            } else {
                yield put({
                    type: UPLOAD_TRANSACTION_FAILED,
                    payload: uploadTransactionData.data
                });
            }
        } catch (error) {
            if (error.response !== undefined) {
                if (error.response.data.abstractResponse.responseStatus === "AUTH001") {
                    yield put({
                        type: BACK_TO_LOGIN,
                        payload: error.response.data.abstractResponse.responseMessage
                    });
                } else {
                    yield put({
                        type: UPLOAD_TRANSACTION_FAILED,
                        payload: error.response.data.abstractResponse.responseMessage
                    });
                }
            } else {
                yield put({
                    type: UPLOAD_TRANSACTION_FAILED,
                    payload: "Sorry, this feature is not accessible at this time."
                });
            }
        }
    }
}

function* postUploadOfflineRedemption({ payload }) {
    if (payload != null) {
        try {
            const uploadOfflineRedemptionData = yield call(uploadOfflineRedemptionApi, payload);
            const responseData = uploadOfflineRedemptionData.data;

            const responseCode = responseData && responseData.responseCode ? responseData.responseCode : null;
            const abstractResponse =
                responseData && responseData.abstractResponse ? responseData.abstractResponse : null;
            const responseStatus = abstractResponse ? abstractResponse.responseStatus : null;

            const isSuccess =
                responseCode === "MEM000" ||
                responseCode === "INQ000" ||
                responseCode === "INQ001" ||
                responseCode === "BUT000" ||
                responseStatus === "MEM000" ||
                responseStatus === "INQ000" ||
                responseStatus === "INQ001" ||
                responseStatus === "BUT000" ||
                uploadOfflineRedemptionData.status === 200 ||
                uploadOfflineRedemptionData.status === 201;

            if (isSuccess) {
                yield put({
                    type: UPLOAD_OFFLINE_REDEMPTION_SUCCESS,
                    payload: responseData
                });
            } else {
                yield put({
                    type: UPLOAD_OFFLINE_REDEMPTION_FAILED,
                    payload: responseData
                });
            }
        } catch (error) {
            if (error.response !== undefined) {
                const errorData = error.response.data;
                const errorAbstractResponse =
                    errorData && errorData.abstractResponse ? errorData.abstractResponse : null;
                const responseStatus = errorAbstractResponse ? errorAbstractResponse.responseStatus : null;
                const responseCode = errorData && errorData.responseCode ? errorData.responseCode : null;

                if (responseStatus === "AUTH001" || responseCode === "AUTH001") {
                    const authMessage =
                        (errorAbstractResponse && errorAbstractResponse.responseMessage) ||
                        errorData.responseMessage ||
                        "Session expired. Please login again.";

                    yield put({
                        type: BACK_TO_LOGIN,
                        payload: authMessage
                    });
                } else {
                    yield put({
                        type: UPLOAD_OFFLINE_REDEMPTION_FAILED,
                        payload: errorData
                    });
                }
            } else {
                yield put({
                    type: UPLOAD_OFFLINE_REDEMPTION_FAILED,
                    payload: {
                        responseMessage: "Sorry, this feature is not accessible at this time.",
                        abstractResponse: {
                            responseMessage: "Sorry, this feature is not accessible at this time."
                        },
                        failedList: []
                    }
                });
            }
        }
    }
}

function* postApprovalMember({ payload }) {
    if (payload != null) {
        try {
            let approvalMemberData = yield call(approvalMemberApi, payload);
            if (approvalMemberData.data.abstractResponse.responseStatus === "MEM000") {
                yield put({
                    type: APPROVAL_MEMBER_SUCCESS,
                    payload: approvalMemberData.data.member
                });
            } else {
                yield put({
                    type: APPROVAL_MEMBER_FAILED,
                    payload: approvalMemberData.data.abstractResponse.responseMessage
                });
            }
        } catch (error) {
            if (error.response !== undefined) {
                if (error.response.data.abstractResponse.responseStatus === "AUTH001") {
                    yield put({
                        type: BACK_TO_LOGIN,
                        payload: error.response.data.abstractResponse.responseMessage
                    });
                } else {
                    yield put({
                        type: APPROVAL_MEMBER_SUCCESS,
                        payload: error.response.data.abstractResponse.responseMessage
                    });
                }
            } else {
                yield put({
                    type: APPROVAL_MEMBER_FAILED,
                    payload: "Sorry, this feature is not accessible at this time."
                });
            }
        }
    }
}

function* postMemberDelinquency({ payload }) {
    if (payload != null) {
        try {
            const responseData = yield call(memberDelinquencyApi, payload);
            if (responseData.data.abstractResponse.responseStatus === "INQ000") {
                yield put({
                    type: MEMBER_DELINQUENCY_SUCCESS,
                    payload: responseData.data
                });
            } else {
                yield put({
                    type: MEMBER_DELINQUENCY_FAILED,
                    payload: responseData.data.abstractResponse.responseMessage
                });
            }
        } catch (error) {
            if (error.response !== undefined) {
                if (error.response.data.abstractResponse === undefined) {
                    yield put({
                        type: MEMBER_DELINQUENCY_FAILED,
                        payload: "Sorry, this feature is not accessible at this time."
                    });
                } else if (error.response.data.abstractResponse.responseStatus === "AUTH001") {
                    yield put({
                        type: BACK_TO_LOGIN,
                        payload: error.response.data.abstractResponse.responseMessage
                    });
                } else {
                    yield put({
                        type: MEMBER_DELINQUENCY_FAILED,
                        payload: error.response.data.abstractResponse.responseMessage
                    });
                }
            } else {
                yield put({
                    type: MEMBER_DELINQUENCY_FAILED,
                    payload: "Sorry, this feature is not accessible at this time."
                });
            }
        }
    }
}

function* postViewMemberDelinquency({ payload }) {
    if (payload != null) {
        try {
            const responseData = yield call(viewMemberDelinquencyApi, payload);
            if (responseData.data.abstractResponse.responseStatus === "INQ000") {
                yield put({
                    type: VIEW_MEMBER_DELINQUENCY_SUCCESS,
                    payload: responseData.data
                });
            } else {
                yield put({
                    type: VIEW_MEMBER_DELINQUENCY_FAILED,
                    payload: responseData.data.abstractResponse.responseMessage
                });
            }
        } catch (error) {
            if (error.response !== undefined) {
                if (error.response.data.abstractResponse === undefined) {
                    yield put({
                        type: VIEW_MEMBER_DELINQUENCY_FAILED,
                        payload: "Sorry, this feature is not accessible at this time."
                    });
                } else if (error.response.data.abstractResponse.responseStatus === "AUTH001") {
                    yield put({
                        type: BACK_TO_LOGIN,
                        payload: error.response.data.abstractResponse.responseMessage
                    });
                } else {
                    yield put({
                        type: VIEW_MEMBER_DELINQUENCY_FAILED,
                        payload: error.response.data.abstractResponse.responseMessage
                    });
                }
            } else {
                yield put({
                    type: VIEW_MEMBER_DELINQUENCY_FAILED,
                    payload: "Sorry, this feature is not accessible at this time."
                });
            }
        }
    }
}

function* fetchPointDetail({ payload }) {
    if (payload != null) {
        try {
            let response = yield call(getPointDetailApi, payload);

            if (response.data.abstractResponse.responseStatus === "INQ000") {
                yield put({
                    type: GET_POINT_DETAIL_SUCCESS,
                    payload: response.data.memberPointDetails
                });
            } else {
                yield put({
                    type: GET_POINT_DETAIL_FAILED,
                    payload: response.data.abstractResponse.responseMessage
                });
            }
        } catch (error) {
            if (error.response !== undefined) {
                if (error.response.data.abstractResponse.responseStatus === "AUTH001") {
                    yield put({
                        type: BACK_TO_LOGIN,
                        payload: error.response.data.abstractResponse.responseMessage
                    });
                } else {
                    yield put({
                        type: GET_POINT_DETAIL_FAILED,
                        payload: error.response.data.abstractResponse.responseMessage
                    });
                }
            } else {
                yield put({
                    type: GET_POINT_DETAIL_FAILED,
                    payload: "Sorry, this feature is not accessible at this time."
                });
            }
        }
    }
}

function* postDeleteMember({ payload }) {
    if (payload != null) {
        const { ok, data, message } = yield* apiHandler(deleteMemberApi, payload, {
            successCodes: ['MEM907', ...IDP_MUTATION_SUCCESS],
        });

        if (ok) {
            yield put({ type: DELETE_MEMBER_SUCCESS, payload: data });
        } else {
            yield put({ type: DELETE_MEMBER_FAILED, payload: message });
        }
    }
}

function* fetchSearchHistory({ payload }) {
    if (payload != null) {
        try {
            let historyData = yield call(searchHistoryApi, payload);
            if (historyData.data.abstractResponse.responseStatus === "INQ000") {
                yield put({ type: SEARCH_HISTORY_SUCCESS, payload: historyData.data });
            } else if (historyData.data.abstractResponse.responseStatus === "TRX020") {
                yield put({ type: SEARCH_HISTORY_SUCCESS, payload: historyData.data });
            } else {
                yield put({ type: SEARCH_HISTORY_FAILED, payload: historyData.data });
            }
        } catch (error) {
            if (error.response !== undefined) {
                if (error.response.data.abstractResponse.responseStatus === "AUTH001") {
                    yield put({ type: BACK_TO_LOGIN, payload: error.response.data.abstractResponse.responseMessage });
                } else {
                    yield put({
                        type: SEARCH_HISTORY_FAILED,
                        payload: error.response.data.abstractResponse.responseMessage
                    });
                }
            } else {
                yield put({
                    type: SEARCH_HISTORY_FAILED,
                    payload: "Sorry, this feature is not accessible at this time."
                });
            }
        }
    }
}

function* fetchDownloadHistory({ payload }) {
    try {
        const historyData = yield call(downloadHistoryApi, payload);
        const contentDisposition = historyData.headers["content-disposition"];
        let downloadFileName = payload.fileName;
        if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
            if (fileNameMatch && fileNameMatch.length === 2) {
                downloadFileName = fileNameMatch[1];
            }
        }

        const url = window.URL.createObjectURL(new Blob([historyData.data]));

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", downloadFileName);

        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);

        yield put({ type: DOWNLOAD_HISTORY_SUCCESS, payload: { message: "Download started" } });
    } catch (error) {
        if (error.response !== undefined) {
            if (error.response.data.abstractResponse.responseStatus === "AUTH001") {
                yield put({ type: BACK_TO_LOGIN, payload: error.response.data.abstractResponse.responseMessage });
            } else {
                yield put({
                    type: DOWNLOAD_HISTORY_FAILED,
                    payload: error.response.data.abstractResponse.responseMessage
                });
            }
        } else {
            yield put({
                type: DOWNLOAD_HISTORY_FAILED,
                payload: "Sorry, this feature is not accessible at this time."
            });
        }
    }
}

export function* searchMembers() {
    yield takeEvery(SEARCH_MEMBERS, fetchSearchMembers);
}

export function* searchNonMembers() {
    yield takeEvery(SEARCH_NON_MEMBERS, fetchSearchNonMembers);
}

export function* getNonMemberPointTransaction() {
    yield takeEvery(NON_MEMBER_POINT_TRANSACTION, fetchNonMemberPointTransaction);
}

export function* viewMember() {
    yield takeEvery(VIEW_MEMBER, fetchViewMember);
}

export function* changeStatusMember() {
    yield takeEvery(CHANGE_STATUS_MEMBER, postChangeStatusMember);
}

export function* approvalMember() {
    yield takeEvery(APPROVAL_MEMBER, postApprovalMember);
}

export function* uploadMember() {
    yield takeEvery(UPLOAD_MEMBER, postUploadMember);
}

export function* uploadTransaction() {
    yield takeEvery(UPLOAD_TRANSACTION, postUploadTransaction);
}

export function* uploadOfflineRedemption() {
    yield takeEvery(UPLOAD_OFFLINE_REDEMPTION, postUploadOfflineRedemption);
}

export function* memberDelinquency() {
    yield takeEvery(MEMBER_DELINQUENCY, postMemberDelinquency);
}

export function* viewMemberDelinquency() {
    yield takeEvery(VIEW_MEMBER_DELINQUENCY, postViewMemberDelinquency);
}

export function* getPointDetail() {
    yield takeEvery(GET_POINT_DETAIL, fetchPointDetail);
}

export function* deleteMember() {
    yield takeEvery(DELETE_MEMBER, postDeleteMember);
}

export function* searchHistory() {
    yield takeEvery(SEARCH_HISTORY, fetchSearchHistory);
}

export function* downloadHistory() {
    yield takeEvery(DOWNLOAD_HISTORY, fetchDownloadHistory);
}

// yield all
export default function* rootSaga() {
    yield all([
        fork(searchMembers),
        fork(searchNonMembers),
        fork(viewMember),
        fork(changeStatusMember),
        fork(approvalMember),
        fork(uploadMember),
        fork(uploadTransaction),
        fork(uploadOfflineRedemption),
        fork(getNonMemberPointTransaction),
        fork(memberDelinquency),
        fork(viewMemberDelinquency),
        fork(getPointDetail),
        fork(deleteMember),
        fork(searchHistory),
        fork(downloadHistory)
    ]);
}
